module.exports = __webpack_public_path__ + "img/quizz_logo.6ade0348.png";